<template>
    <toolbar-option type="stacked">
        <template slot="secondary">
            <dropdown
                :options="stateOptions"
                :value="state"
                native
                @input="onStateInput"
            />
        </template>

        <template slot="primary">
            <dropdown
                :options="typeOptions"
                :value="type"
                native
                @input="onTypeInput"
            />

            <div v-if="type">
                <br>

                <slider
                    :value="sliderIndex"
                    :values="themeObjectValues"
                    @input="onInput"
                />
            </div>
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option-slider';

export default {
    name: 'image-filter',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Image Filter',
            state: '',
            tailwindDefinitionProp: 'blur',
            tailwindDefinitionProps: ['blur', 'contrast', 'grayscale'],
            type: '',

            stateOptions: [
                { text: 'Default', value: '' },
                { text: 'Hover', value: 'hover' },
            ],

            typeOptions: [
                { text: 'None', value: '' },
                { text: 'Blur', value: 'blur' },
                { text: 'Contrast', value: 'contrast' },
                { text: 'Grayscale', value: 'grayscale' },
            ],
        };
    },

    methods: {
        onInput(index) {
            let flexClassNew;

            const removeAtZeroProps = ['blur', 'grayscale'];
            const removeAtZero = index === 0 && removeAtZeroProps.includes(this.type);

            if (removeAtZero && this.state !== 'hover') {
                this.removeFlexClass(this.state || 'default');
            } else {
                flexClassNew = this.addFlexClass({
                    value: this.themeObjectValues[index],
                    side: this.side,
                    state: this.state,
                });
            }

            this.sliderIndex = index;
            this.onOptionChange(flexClassNew);
        },

        onStateInput(stateNew) {
            this.state = stateNew;
            this.setSlider();
        },

        onTypeInput(typeNew) {
            // this needs to be called before the tailwind definition prop is changed
            this.removeFlexClass();

            this.type = typeNew;
            this.tailwindDefinitionProp = typeNew || this.tailwindDefinitionProp;
            this.sliderIndex = typeNew === 'contrast' ? this.themeObjectValues.indexOf('100%') : 0;

            this.onOptionChange();
            this.setChangedData(true);
        },

        onSelectedElement() {
            // loop through each tailwind prop to see if there is a flex class attached to any of them
            this.tailwindDefinitionProps.forEach((prop) => {
                if (this.flexClass) return;

                this.tailwindDefinitionProp = prop;
            });

            if (this.flexClass) {
                this.setData();
            } else {
                this.resetData();
            }
        },

        setData() {
            const { state, tailwindDefinitionProp } = this.flexClassDefinition;

            this.state = state;
            this.type = tailwindDefinitionProp;
            this.setSlider();
        },

        resetData() {
            this.state = '';
            this.type = '';
            this.sliderIndex = 0;
        },
    },
};
</script>
